// Vendor
import * as queryString from 'query-string';

import { SearchQueryAdapter } from 'stores/adapters/search-query-adapter';

// Stores
import { SearchCriteriaModel } from 'stores/models/search-criteria-model';
import { SearchResultsStore } from 'stores/search-results-store';

const HOTEL_NAME = '1'; // eg: `hicago-Mariott-Suites-Deerfield`
const INFOSITE = '2'; // eg: `Hotel-Information`

export const generateAddAnotherPropertyURL = (searchCriteria: SearchCriteriaModel, searchResults: SearchResultsStore) => {
  const sqaParsedOut = SearchQueryAdapter.parseOut(searchCriteria.toJSON([HOTEL_NAME, INFOSITE]));

  searchResults.expandForm = true;

  return {
    pathname: '/Hotel-Search',
    search: queryString.stringify({ ...sqaParsedOut, useRewards: false })
  };
};
